import { messageActions } from "../features/message/messageSlice";
import i18n from "../i18n";
import type { AppDispatch } from "./store";

type ErrorMessageInput = {
  error?: { message?: string };
  payload?: unknown;
  rejectedWithValue?: boolean;
  requestId?: string;
};

const getErrorMessageText = ({
  error,
  payload,
  rejectedWithValue,
  requestId,
}: ErrorMessageInput) => {
  let errorMessage = error?.message || "internal_error";

  if (rejectedWithValue && typeof payload === "string") {
    errorMessage = payload;
  }

  const baseText = i18n.exists(`errors:${errorMessage}`)
    ? i18n.t(`errors:${errorMessage}`)
    : errorMessage;

  return requestId ? `${baseText} ${requestId}` : baseText;
};

export const setAsyncErrorMessage = (
  dispatch: AppDispatch,
  params: ErrorMessageInput,
) => {
  dispatch(
    messageActions.setMessage({
      text: getErrorMessageText(params),
      type: "error",
    }),
  );
};

const getErrorMessage = (error: unknown) => {
  if (error instanceof Error) {
    return error.message;
  }
  if (
    typeof error === "object" &&
    error !== null &&
    "message" in error &&
    typeof error.message === "string"
  ) {
    return error.message;
  }
  return undefined;
};

export const runHandledApiCall = async <T>({
  dispatch,
  run,
}: {
  dispatch: AppDispatch;
  run: () => Promise<T>;
}) => {
  try {
    return await run();
  } catch (error) {
    setAsyncErrorMessage(dispatch, {
      error: { message: getErrorMessage(error) },
    });
    throw error;
  }
};
